export default "__VITE_ASSET__DMidPSKH__"